/* Original name trustyle.wireframe-cell */

import * as React from 'react'
import { css, keyframes } from '@emotion/react'

const loading = keyframes`
  0% {
    background-position: 100% 0
  }
  100% {
    background-position: -100% 0
  }
`

const wireFrameCellCss = css({
  '.load': {
    backgroundImage: 'linear-gradient(to right, #DFDFE1, #F2F2F3, #DFDFE1)',
    backgroundSize: '200% 100px',
    animation: `${loading} 1.5s infinite ease`,
  },
})

const WireFrameCell = ({ styles }) => (
  <span
    css={wireFrameCellCss}
    sx={{
      display: 'block',
      backgroundColor: '#DFDFE1',
      ...styles,
    }}
  >
    <span
      className={'load'}
      sx={{
        width: '100%',
        height: '100%',
        display: 'block',
      }}
    ></span>
  </span>
)

export default WireFrameCell
